import _ from 'lodash';
import { connect } from 'react-redux';
import { subscriptions } from 'app/selectors/subscriptions';

export default function loadSettings(Component) {
  const mapStateToProps = (state, ownProps) => ({
    features: _.get(state, 'common.features'),
    isRestricted: subscriptions.getIsRestricted(state),
    ...ownProps,
  });

  return connect(mapStateToProps)(Component);
}



// WEBPACK FOOTER //
// ./app/containers/settings/settings-nav.js